/**
 * @generated SignedSource<<eafdbab271716ee36016c0f9a560e557>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
export type AddElementsPoolElementInput = {
  answerOptions: ReadonlyArray<AnswerOptionV2Input>;
  answeringType: string;
  clientMutationId?: string | null | undefined;
  imageId?: string | null | undefined;
  poolId: string;
  question: string;
  title: string;
};
export type AnswerOptionV2Input = {
  answer: string;
  imageRef?: string | null | undefined;
  isCorrect: boolean;
};
export type MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation$variables = {
  input: AddElementsPoolElementInput;
};
export type MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation$data = {
  readonly Admin: {
    readonly Elementspool: {
      readonly addElementsPoolElement: {
        readonly pool: {
          readonly elements: ReadonlyArray<{
            readonly elementType: ElementTypeV2;
            readonly id: string;
            readonly question: string;
            readonly title: string;
            readonly " $fragmentSpreads": FragmentRefs<"PoolElementForm_ElementV2Fragment">;
          }>;
          readonly id: string;
        };
      } | null | undefined;
    };
  };
};
export type MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation = {
  response: MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation$data;
  variables: MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elementType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementspoolAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Elementspool",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddElementsPoolElementPayload",
                "kind": "LinkedField",
                "name": "addElementsPoolElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementsPool",
                    "kind": "LinkedField",
                    "name": "pool",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleChoiceElementV2",
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PoolElementForm_ElementV2Fragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementspoolAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Elementspool",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddElementsPoolElementPayload",
                "kind": "LinkedField",
                "name": "addElementsPoolElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementsPool",
                    "kind": "LinkedField",
                    "name": "pool",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleChoiceElementV2",
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "answeringType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerOptionV2",
                                    "kind": "LinkedField",
                                    "name": "answerOptions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "answer",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isCorrect",
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MultipleChoiceElementV2",
                                "abstractKey": null
                              }
                            ],
                            "type": "ElementV2",
                            "abstractKey": "__isElementV2"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "edb53a9cc7893501c577ae4ef79df46b",
    "id": null,
    "metadata": {},
    "name": "MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation",
    "operationKind": "mutation",
    "text": "mutation MultipleChoiceElementsPool_CreateMultipleChoiceElementV2Mutation(\n  $input: AddElementsPoolElementInput!\n) {\n  Admin {\n    Elementspool {\n      addElementsPoolElement(input: $input) {\n        pool {\n          id\n          elements {\n            id\n            elementType\n            title\n            question\n            ...PoolElementForm_ElementV2Fragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment on MultipleChoiceElementV2 {\n  id\n  title\n  question\n  image {\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    isCorrect\n    image {\n      id\n    }\n  }\n}\n\nfragment PoolElementForm_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  title\n  elementType\n  ... on MultipleChoiceElementV2 {\n    ...MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "6851395dd4d4f244f285663394118540";

export default node;
